const common: Record<string, string> = {
  'app.name': 'WZap PRO',
  'app.tagline': 'Marketing via WhatsApp simplificado',
  'nav.dashboard': 'Dashboard',
  'nav.contacts': 'Contatos',
  'nav.groups': 'Grupos',
  'nav.campaigns': 'Campanhas',
  'nav.templates': 'Templates',
  'nav.reports': 'Relatórios',
  'nav.settings': 'Configurações',
  'nav.logs': 'Logs',
  'auth.login': 'Entrar',
  'auth.logout': 'Sair',
  'auth.email': 'Email',
  'auth.password': 'Senha',
  'auth.forgot_password': 'Esqueceu a senha?',
  'auth.no_account': 'Não tem conta?',
  'auth.create_account': 'Criar conta gratuita',
  'auth.welcome_back': 'Bem-vindo de volta',
  'auth.login_subtitle': 'Faça login para acessar seu painel',
  'dashboard.title': 'Dashboard',
  'dashboard.subtitle': 'Visão geral do desempenho das suas campanhas',
  'dashboard.contacts': 'Contatos',
  'dashboard.campaigns': 'Campanhas',
  'dashboard.sent': 'Enviadas',
  'dashboard.delivered': 'Entregues',
  'dashboard.read': 'Lidas',
  'dashboard.replied': 'Respondidas',
  'dashboard.active_campaigns': 'Campanhas Ativas',
  'dashboard.scheduled': 'Agendadas',
  'dashboard.failures': 'Falhas',
  'dashboard.recent_logs': 'Logs Recentes',
};

export default common;